export const locale = {
    lang: 'de',
    data: {
        'TOOLBAR': {
          'PERFIL': 'Mein Profil' ,
          'INBOX': 'Posteingang',
          'LOGOUT': 'Abmelden',
          'ADMIN': 'Angemeldet als:',
          'LOGIN':'Angemeldet bei: ',
          'GOPROFILE':'Profil',
            'CITIES':{
                '0':'',
                '1':'Mexico City',
                '2':'San salvador',
                '3':'Hong kong',
                '4':'Singapure',
                '5':'Istanbul',
                '6':'Victoria',
                '8':'Mexico City',
                '11':'São Paulo',
                '15':'Madrid',
                'IZZI':'Mexico City',
                'MX':'Mexico City',
                '19':'Mexico City',
            },
            'LOGOUT_MODAL': {
              'TEXTO': 'Möchten Sie sich wirklich abmelden?',
              'SI': 'Ja',
              'NO': 'Nein'
            }
        }
    }
};
